import Vue from 'vue'
import store from '@/store'
import './aliyun-sdk.min'
import './oss-js-upload'
import {debounce} from '@deanwu/vue-component-library'

let _token, _ossUpload, _expiration;
let app = new Vue();

const getToken = debounce(function() {
	return new Promise(resolve => {
		app.request({
			url: '/oss/token',
			loading: true,
			success: data => {
				_token = data;
				_ossUpload = new OssUpload({
					bucket: data.bucketName,
					endpoint: data.host,
					// 如果文件大于 chunkSize 则分块上传, chunkSize 不能小于 100KB 即 102400
					chunkSize: 1024 * 500, // 分片大小 500kb
					// 分块上传的并发数
					concurrency: 1,
					/**
					 * 注意: 虽然使用 accessKeyId 和 secretAccessKey 可以进行上传, 但是存在泄露风险,
					 * 因此强烈建议使用下面的 STS token 只有在确认不会出现泄露风险的情况下, 才使用 aliyunCredential
					 */
					stsToken: data
				});
				_expiration = new Date(data.Expiration).getTime();
				resolve(true);
			},
			fail: () => {
				resolve(false);
			}
		});
	});
}, 500, true)

const getVolume = debounce(function() {
	return new Promise(resolve => {
		app.request({
			url: '/oss/file/directory/size',
			loading: true,
			success: data => {
				resolve(data.total_size / 1024 / 1024);
			},
			fail: () => {
				resolve(0);
				return false;
			}
		});
	});
}, 500, true)

function ossSign(paths) {
	return new Promise(resolve => {
		app.request({
			url: '/oss/weboffice/getPreViewUrl',
			data: {
				file_paths: paths,
				urlType: 3
			},
			success: resolve
		});
	})
}

function getSaasId() {
	return ($app.$store.state.saasInfo ? $app.$store.state.saasInfo.saas_id : 0) + '/';
}

function getDate() {
	return _token.key.match(/(\d{6})\/$/)[0];
}

function getUuid() {
	let len = 20;// 20长度
	let radix = 16;// 16进制
	let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
	let uuid = [], i;
	radix = radix || chars.length;
	if (len) {
		for (i = 0; i < len; i++)
			uuid[i] = chars[0 | Math.random() * radix];
	} else {
		let r;
		uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
		uuid[14] = '4';
		for (i = 0; i < 36; i++) {
			if (!uuid[i]) {
				r = 0 | Math.random() * 16;
				uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
			}
		}
	}
	return uuid.join('').toLowerCase() + '/';
}

function suffixLowerCase(name) {
	let dotIndex = name.lastIndexOf('.');
	if (dotIndex <= 0) return name;
	return name.slice(0, dotIndex) + name.slice(dotIndex).toLowerCase();
}

/**
 * @param {Function} opt.success [单个文件上传回调]
**/
async function upload(files, opt) {
	if (files.length == 0) return;

	if (store.getters.freeEdition && files.find(item => item.file.size / 1024 / 1024 > 5)) {
		app.getSys().$refs.uploadRemind.open();
		app.$loadOver();
		return;
	}

	if (_expiration && _expiration - new Date().getTime() < 60000) {
		_token = null;
		_ossUpload = null;
	}
	
	// if (await getVolume() >= $app.$store.state.saasInfo.max_storage_capacity) {
	// 	app.$message({
	// 		message: '文件存储空间已达上限，请联系软件售后人员'
	// 	});
	// 	return;
	// }
	
	if (!_token && await getToken() === false) {
		return;
	}
	
	let folder = window._uploadConfig && window._uploadConfig.folder
		? window._uploadConfig.folder + '/' + getSaasId() + getUuid()
		: getSaasId() + getDate() + getUuid();
	let filesCount = files.length;
	let errorCount = 0;
	let successCount = 0;
	let errorCode = '';
	
	let fruit = new Array(filesCount);
	
	let loading = document.body._$loading;
	if (files.length > 1) {
		loading && loading.update(`上传中（${successCount}/${files.length}）`);
	} else {
		loading && loading.update('上传中（0%）');
	}
	files.forEach((item, i) => {
		let file = item.file;
		file.file_path = _token.endpoint + folder + suffixLowerCase(file.name);
	
		const upload = function() {
			_ossUpload.upload({
				file: file, // 必传参数, 需要上传的文件对象
				key: folder + suffixLowerCase(file.name), // 必传参数, 文件上传到 oss 后的名称, 包含路径
				maxRetry: 30, //上传失败后重试次数
				/*
				 * OSS支持4个 HTTP
				 * RFC2616(https://www.ietf.org/rfc/rfc2616.txt)协议规定的Header
				 * 字段：
				 * Cache-Control、Expires、Content-Encoding、Content-Disposition。
				 * 如果上传Object时设置了这些Header，则这个Object被下载时，相应的Header值会被自动设置成上传时的值
				 * 可选参数
				 */
				headers: {
					'CacheControl': 'public',
					'Expires': '',
					'ContentEncoding': '',
					'ContentDisposition': '',
					// oss 支持的 header, 目前仅支持 x-oss-server-side-encryption
					'ServerSideEncryption': ''
				},
		
				onprogress: function(e, id) {
					let rate = parseInt((parseFloat(e.loaded) / parseFloat(e.total)) * 100);
					item.progress(rate);
					if (files.length == 1) {
						loading && loading.update(`上传中（${rate}%）`);
					}
				},
		
				oncomplete: function(res, file) {
					item.success(file.file_path);
					fruit[i] = file;
					successCount++;
					if (files.length > 1) {
						loading && loading.update(`上传中（${successCount}/${files.length}）`);
					}
					if (--filesCount == 0) {
						complete();
					}
				},
		
				onerror: function(res) {
					if (!file.retry && ['InvalidAccessKeyId', 'SecurityTokenExpired'].includes(res.code)) {
						file.retry = true;
						setTimeout(async () => {
							await getToken();
							upload();
						}, 500);
					} else {
						item.fail();
						errorCode = res.code;
						errorCount++;
						if (--filesCount == 0) {
							complete();
						}
					}
				}
			});
		}
		upload();
	});

	async function complete(success, fail) {
		if (successCount) {
			let signature = await ossSign(fruit.filter(item => !!item).map(item => item.file_path));

			opt.success(
				fruit.filter(item => !!item).map((item, index) => {
					return {
						path: item.file_path,
						signPath: signature.urls[index],
						fileObj: item
					}
				})
			);
		}
		opt.complete && opt.complete();
		
		if (!window._uploadConfig || window._uploadConfig.message !== false) {
			app.$message({
				message: !errorCount ? '上传成功' : !successCount ? `${'上传失败，请重试'} (${errorCode})` : `${`上传完成，失败${errorCount}个`} (${errorCode})`
			})
		}
		delete window._uploadConfig;

		app.request({
			url: '/oss/upload/success'
		});
	}
}

export default upload
export {
	ossSign
}